import { map } from "rxjs/operators";

import { PolicyType } from "@vowkey/common/admin-console/enums";
import { Organization } from "@vowkey/common/admin-console/models/domain/organization";
import { AutotypeFeatureFlagState } from "@vowkey/common/desktop-native/enums/autotype-feature-flag-state.enum";
import { autotypeFeatureFlagState$ } from "@vowkey/common/desktop-native/services/autotype-feature-flags";
import { ConfigService } from "@vowkey/common/platform/abstractions/config/config.service";

import { BasePolicyEditDefinition } from "../base-policy-edit.component";
import { PolicyCategory } from "../pipes/policy-category";

import { SimpleTogglePolicyComponent } from "./simple-toggle-policy.component";

/**
 * Autotype MVP only: this policy must only be used within the Autotype MVP scope
 * (`AutotypeFeatureFlagState.Mvp`, MVP feature flag on and GA feature flag off).
 */
export class DesktopAutotypeDefaultSettingPolicy extends BasePolicyEditDefinition {
  name = "desktopAutotypePolicyTitleV2";
  description = "desktopAutotypePolicyDescV2";
  descriptionVfo1 = "desktopAutotypePolicyDescVfo1";
  drawerDescriptionVfo1 = "desktopAutotypePolicyDescV2";
  type = PolicyType.AutotypeDefaultSetting;
  category = PolicyCategory.VaultManagement;
  priority = 70;
  component = SimpleTogglePolicyComponent;

  display$(organization: Organization, configService: ConfigService) {
    return autotypeFeatureFlagState$(configService).pipe(
      map((state) => state === AutotypeFeatureFlagState.Mvp),
    );
  }
}
